
















































































































































import { Component, Vue } from "vue-property-decorator";
import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import TiendaOnlineClientes from "@/store/modules/TiendaOnlineClientes-module";
import { ImagenProducto } from "@/shared/dtos/productosAmazon/ImagenProducto";
import { RouterNames } from "@/router/routernames";
import { medicalUserService } from "@/shared/services/user-service";
import { ssmTokenService } from "@/shared/services/token-service";
import ProcesosProducto from "../procesos/Procesos_producto.vue";
import { ProcessoNums } from "../procesos/ProcessoNums";

@Component({
  components: { ProcesosProducto },
})
export default class productoTiendaOnline extends Vue {
  public mainImage = "https://via.placeholder.com/500x500.png?text=Producto";
  public prodcuto: ProductoAmazon = new ProductoAmazon();
  public id_producto = -1;

  async created() {
    window.scrollTo(0, 0);

    const id = Number(this.$route.params.id); // Obtener el ID desde los parámetros de la ruta
    /*
    if (TiendaOnlineClientes.TiendaOnlineClienteses.length === 0) {
      if (ssmTokenService.hasToken() && medicalUserService.hasuser()) {
        await TiendaOnlineClientes.getTiendaOnlineClientesesTodos();
      } else {
        await TiendaOnlineClientes.getTiendaOnlineClienteses();
      }
    }

    // Buscar el cliente en la lista TiendaOnlineClientes
    this.prodcuto = TiendaOnlineClientes.TiendaOnlineClienteses.find(
      (prodcuto) => prodcuto.id === id
    )!;
*/
    this.id_producto = id;
    if (
      this.$route.query.m &&
      (this.$route.meta.mayorista === undefined ||
        this.$route.meta.mayorista === null ||
        this.$route.meta.mayorista == false)
    ) {
      this.$route.meta.mayorista = this.$route.query.m === "1";
    }

    await TiendaOnlineClientes.getTiendaOnlineClientes(id);

    this.prodcuto = TiendaOnlineClientes.TiendaOnlineClientes;

    this.mainImage = this.prodcuto.hiRes;
    //TiendaOnlineClienteses
  }

  get esta_logeado() {
    return ssmTokenService.hasToken() && medicalUserService.hasuser();
  }

  generateListItems(text: string): string[] {
    // Divide el texto en oraciones usando un delimitador básico como "."
    const sentences = text
      .split(/\. (?=[A-Z])/)
      .map((sentence) => sentence.trim());
    return sentences.map((sentence) => `<li>${sentence}.</li>`);
  }
  changeMainImage(image: ImagenProducto) {
    this.mainImage = image.hiRes;
  }
  get descuento() {
    const descuento =
      ((this.prodcuto.precio_amazon - this.prodcuto.precio_venta) /
        this.prodcuto.precio_amazon) *
      100;
    return `${descuento.toFixed(2)}%`;
  }
  get estado() {
    if (!this.prodcuto) return "En stock. Envío através de Wallapop.";
    if (this.prodcuto.vendido) return "Vendido";
    switch (this.prodcuto.estado) {
      case ProcessoNums.Disponible:
        return "En stock. Envío através de Wallapop.";
      case ProcessoNums.Reservado:
        return "Reservado";
      case ProcessoNums.VendidoEfectivo:
        return "Vendido";
      case ProcessoNums.VendidoTarjeta:
        return "Vendido";
      case ProcessoNums.Devolucion:
        return "Articulo devuleto Devolución";
      case ProcessoNums.MermaRoto:
        return "Articulo Roto";
      case ProcessoNums.Envio:
        return "Articulo en envio";
      case ProcessoNums.PendientePago:
        return "Articulo pendiente de pago";
      case ProcessoNums.Reparacion:
        return "Articulo en reparación";
    }
    return this.prodcuto.estado;
  }
  goto() {
    //this.$router.push({ name: RouterNames.tienda_productos });
    this.$router.back();
  }
}
